import { useEffect, useRef } from "react";
import useTableCtx from "../tableContext/useTableCtx";
import TableFilterSelect from "./TableFilterSelect";

function FilterTable({
  value,
  label,
  withFilter,
  filterDefaultIdx,
}: {
  value: string;
  label?: string;
  withFilter: {
    value: string | number;
    label: string | number;
  }[];
  filterDefaultIdx?: number;
}) {
  const { handleTableSearch, tableSearch } = useTableCtx()!;
  const initializedField = useRef<string>();

  const tableSearchValue = tableSearch?.[value];

  const filterDefaultIdxValue = filterDefaultIdx ?? 0;
  const defaultFilterValue =
    withFilter[filterDefaultIdxValue]?.value ?? withFilter[0]?.value;
  const selectedValue = tableSearchValue ?? defaultFilterValue ?? null;
  const hasOptions = withFilter.length > 0;
  const hasEmptyOption = withFilter.some((option) => option.value === "");

  useEffect(() => {
    if (!value || !hasOptions || initializedField.current === value) return;
    initializedField.current = value;

    // useTableConfig starts filter fields at "" before applying their default.
    // Initialize once so a later deliberate empty-option selection is preserved.
    const needsDefault =
      tableSearchValue == null ||
      (tableSearchValue === "" &&
        (filterDefaultIdx !== undefined || !hasEmptyOption));

    if (needsDefault && defaultFilterValue !== undefined) {
      handleTableSearch(value, defaultFilterValue, { resetPage: false });
    }
  }, [
    defaultFilterValue,
    filterDefaultIdx,
    handleTableSearch,
    hasEmptyOption,
    hasOptions,
    tableSearchValue,
    value,
  ]);

  return (
    <div className="w-full min-w-0">
      {selectedValue !== null && (
        <TableFilterSelect
          name={value}
          label={`Filtreaza ${label ?? value}`}
          value={selectedValue}
          options={withFilter}
          fallbackOptionIndex={filterDefaultIdx}
          onChange={(nextValue) => handleTableSearch(value, nextValue)}
        />
      )}
    </div>
  );
}

export default FilterTable;
